import { render, staticRenderFns } from "./CourseProgress.vue?vue&type=template&id=36da4e5e&scoped=true&"
import script from "./CourseProgress.vue?vue&type=script&lang=js&"
export * from "./CourseProgress.vue?vue&type=script&lang=js&"
import style0 from "./CourseProgress.vue?vue&type=style&index=0&id=36da4e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da4e5e",
  null
  
)

export default component.exports